import { render, staticRenderFns } from "./MenuCategoriesHome.vue?vue&type=template&id=af709cc6&"
import script from "./MenuCategoriesHome.vue?vue&type=script&lang=js&"
export * from "./MenuCategoriesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports